import { Link } from "react-router-dom";
import styled from "styled-components";

export const NavigatorMain = styled.div`
  width: 100%;
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 4px;
  background-color: ${props => props.theme.color.gray};
  position: relative;
  z-index: 998;
`;

export const NavigatorItem = styled(Link)`
  padding: ${props => props.theme.spacer.bigger};
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;
  position: relative;
  font-size: ${props => props.theme.fontSize.fs10};
  /* border-bottom: 2px solid #ffffff; */
  transition: all 1s;

  /* &:last-child .sub-nav {
    right: 0;
  } */

  &:hover {
    text-decoration: none;
  }
  &:hover .sub-nav {
    display: flex;
  }

  &:has(.sub-nav:hover) {
    .main-nav-title {
      color: ${props => props.theme.color.secondary};
    }
  }
`;

export const NavigatorItemTitle = styled.div`
  &:after {
    display: block;
    width: 0;
    height: 2px;
    position: absolute;
    top: 35px;
    right: -18px;
    content: " ";
    transition: all 0.4s;
    animation-fill-mode: backforwards;
  }

  &:hover:after {
    width: 100%;
    height: 2px;
    background: ${props => props.theme.color.secondary};
    right: 0;
  }

  &:hover {
    color: ${props => props.theme.color.secondary};
  }

  @media screen and (max-width: 800px) {
    padding: 2px;
    font-size: ${props => props.theme.fontSize.fs12};
  }
`;

export const NavigatorSub = styled.div`
  /* width: 371px; */
  position: absolute;
  top: 34px;
  display: none;
  flex-direction: row;
  flex-wrap: wrap;
  gap: 1px;
  background-color: ${props => props.theme.color.secondary};
  overflow: hidden;
  border: 1px solid ${props => props.theme.color.secondary};
  border-top: none;
  border-bottom-left-radius: 4px;
  border-bottom-right-radius: 4px;
  box-shadow: 0 4px 0 rgba(34,183,219,.4);
  padding: 4px;
  z-index: 999;
`;

export const NavigatorSubItem = styled.div`
  padding: 4px 0;
  background-color: aqua;
  text-align: center;
  font-size: ${props => props.theme.fontSize.fs10};
  color: ${props => props.theme.color.white};
  margin-left: 8px;
  padding-left: 8px;
  background-color: ${props => props.theme.color.secondary};
  cursor: pointer;
  min-width: 180px;
  text-align: left;
  border-left: 3px solid ${props => props.theme.color.secondary};

  &:first-child {
    margin-top: 4px;
  }

  &:last-child {
    margin-bottom: 8px;
  }

  &:hover {
    border-left: 3px solid ${props => props.theme.color.white};
    color: ${props => props.theme.color.white};
  }
`;